import { create } from "zustand";
import { DescriptionDisclosure } from "../../../types/model/promotion";

interface PromotionPageState {
  descriptionDisclosures: DescriptionDisclosure[];
}

export const usePromotionPageStore = create<PromotionPageState>((set) => ({
  descriptionDisclosures: [],
}));
